import styles from "./PolicyPage.module.css";

export default function ReturnPolicy() {
  return (
    <div className={styles.page}>
      <div className={styles.inner}>
        <p className={styles.eyebrow}>Legal</p>
        <h1 className={styles.title}>Return Policy</h1>
        <p className={styles.updated}>Last updated: February 2025</p>
        <div className={styles.divider} />

        <div className={styles.section}>
          <h2>1. General Policy</h2>
          <p>At Ratnapura Gems, we take great pride in the quality and craftsmanship of our products. All sales are considered final once payment has been made. We do not offer refunds or exchanges unless there is a verified manufacturing fault on our part.</p>
        </div>

        <div className={styles.section}>
          <h2>2. Advance Payments</h2>
          <p>Advance payments made for custom jewellery orders, reservations, or any other purpose are strictly non-refundable. By making an advance payment, you acknowledge and agree to this condition.</p>
        </div>

        <div className={styles.section}>
          <h2>3. Manufacturing Faults</h2>
          <p>If you believe your item has a manufacturing fault, you must contact us within <strong>7 days</strong> of receiving your order. Claims made after this period will not be accepted.</p>
          <p>To raise a manufacturing fault claim, please contact us via:</p>
          <ul>
            <li>WhatsApp: +94 76 585 1400</li>
            <li>Instagram: @ratnapuragems</li>
          </ul>
          <p>We will assess the item and, if a genuine manufacturing fault is confirmed, we will offer a repair, replacement, or store credit at our discretion.</p>
        </div>

        <div className={styles.section}>
          <h2>4. Non-Returnable Items</h2>
          <p>The following items are not eligible for return or exchange under any circumstances:</p>
          <ul>
            <li>Custom or personalised jewellery orders</li>
            <li>Items that have been worn, resized, or altered</li>
            <li>Items damaged due to misuse, negligence, or accidental damage</li>
            <li>Loose gemstones once delivered and accepted</li>
          </ul>
        </div>

        <div className={styles.section}>
          <h2>5. Condition of Returned Items</h2>
          <p>Any item approved for return must be sent back in its original condition, unused, and in original packaging. Items that do not meet these conditions will not be accepted.</p>
        </div>

        <div className={styles.section}>
          <h2>6. Contact Us</h2>
          <p>If you have any questions about our return policy, please reach out to us before making a purchase.</p>
          <p>WhatsApp: <a href="https://wa.me/94765851400">+94 76 585 1400</a></p>
          <p>Instagram: <a href="https://instagram.com/ratnapuragems" target="_blank" rel="noreferrer">@ratnapuragems</a></p>
        </div>

        <a href="/" className={styles.backBtn}>← Back to Home</a>
      </div>
    </div>
  );
}